/*MODULES*---------------------------------------------------------------------------------------*/
import { registerLocaleData, LocationStrategy, HashLocationStrategy } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TreeSelectModule } from 'primeng/treeselect';
import { SliderModule } from 'primeng/slider';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { HttpClientModule } from '@angular/common/http';
import { TreeTableModule } from 'primeng/treetable';
import { MenuModule } from 'primeng/menu';
import { DividerModule } from 'primeng/divider';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ListboxModule } from 'primeng/listbox';
import { PanelModule } from 'primeng/panel';
import { StepsModule } from 'primeng/steps';
import { TabViewModule } from 'primeng/tabview';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { RadioButtonModule } from 'primeng/radiobutton';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AccordionModule } from 'primeng/accordion';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToolbarModule } from 'primeng/toolbar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BlockUIModule } from 'primeng/blockui';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
//import { ConfirmationService } from 'primeng/api';

/*COMPONENTS*---------------------------------------------------------------------------------------*/
import { MainComponent } from './components/shared/layout/main.component';
import { HeaderComponent } from './components/shared/layout/header/header.component';
import { FooterComponent } from './components/shared/layout/footer/footer.component';
import { MenuSidebarComponent } from './components/shared/layout/menu-sidebar/menu-sidebar.component';
import { NotificationsDropdownMenuComponent } from './components/shared/layout/header/notifications-dropdown-menu/notifications-dropdown-menu.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoadingPanelComponent } from "./components/shared/layout/loading-panel/loading-panel.component";

import { httpInterceptorProvider } from './services/interceptors';
import { PickListModule } from 'primeng/picklist';
import { MultiSelectModule } from 'primeng/multiselect';
import { DataViewModule } from 'primeng/dataview';
import { ToastModule } from 'primeng/toast';
import { InplaceModule } from 'primeng/inplace';
import { SlideMenuModule } from 'primeng/slidemenu';
import { ImageModule } from 'primeng/image';

import { LoginComponent } from './components/shared/login/login.component';
import { MapComponent } from './components/shared/map/map.component';
import { CcAccountLinesComponent } from './components/shared/cc-account-lines/cc-account-lines.component';
import { CcAccountTrafficComponent } from './components/shared/cc-account-traffic/cc-account-traffic.component';
import { CcLineDelayDropGraphComponent } from './components/cc-portal/cc-line-delay-drop-graph/cc-line-delay-drop-graph.component';
import { CcLineStatisticsComponent } from './components/cc-portal/cc-line-statistics/cc-line-statistics.component';
import { CcLineSummaryComponent } from './components/cc-portal/cc-line-summary/cc-line-summary.component';
import { CcPortalComponent } from './components/cc-portal/cc-portal/cc-portal.component';
import { CcTicketComponent } from './components/cc-portal/cc-ticket/cc-ticket.component';
import { LineTrafficDigestGraphComponent } from './components/cc-portal/line-traffic-digest-graph/line-traffic-digest-graph.component';
import { LlTotalSummaryComponent } from './components/dashboard/ll-total-summary/ll-total-summary.component';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { BillingComponent } from './components/SideComponents/billing/billing.component';
import { ServiceHistoryComponent } from './components/SideComponents/service-history/service-history.component';
import { PerformanceGraphsComponent } from './components/SideComponents/performance-graphs/performance-graphs.component';
import { StatusHistoryComponent } from './components/SideComponents/status-history/status-history.component';
import { TrafficGraphComponent } from './components/SideComponents/traffic-graph/traffic-graph.component';
import { SingleGraphComponent } from './components/SideComponents/single-graph/single-graph.component';
import { SplashComponent } from './components/shared/splash/splash.component';
import { BundleLinesComponent } from './components/cc-portal/bundle-lines/bundle-lines.component';
import { HatterasContainerComponent } from './components/shared/hatteras-container/hatteras-container.component';
import { NormalContainerComponent } from './components/shared/normal-container/normal-container.component';
import { AvilabilityGraphComponent } from './components/cc-portal/avilability-graph/avilability-graph.component';
import { TotalAccountGraphsComponent } from './components/shared/total-account-graphs/total-account-graphs.component';
import { CreateTicketComponent } from './components/cc-portal/create-ticket/create-ticket.component';
import { SpeedKbToMbPipe } from './speed-kb-to-mb.pipe';
import { ContactUsComponent } from './components/contact-us/contact-us.component';

registerLocaleData(localeEn, 'en-EN');

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    HeaderComponent,
    FooterComponent,
    MenuSidebarComponent,
    NotificationsDropdownMenuComponent,
    DashboardComponent,
    LoadingPanelComponent,
    MapComponent,
    CcAccountLinesComponent,
    CcAccountTrafficComponent,
    CcLineDelayDropGraphComponent,
    CcLineStatisticsComponent,
    CcLineSummaryComponent,
    CcPortalComponent,
    CcTicketComponent,
    LineTrafficDigestGraphComponent,
    LoginComponent,
    LlTotalSummaryComponent,
    BillingComponent,
    ServiceHistoryComponent,
    PerformanceGraphsComponent,
    StatusHistoryComponent,
    TrafficGraphComponent,
    SingleGraphComponent,

    SplashComponent,
      BundleLinesComponent,
      HatterasContainerComponent,
      NormalContainerComponent,
      AvilabilityGraphComponent,
      TotalAccountGraphsComponent,
      CreateTicketComponent,
      SpeedKbToMbPipe,
      ContactUsComponent,

  ],
  imports: [
    AutoCompleteModule,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    TooltipModule,
    DropdownModule,
    FileUploadModule,
    InputTextModule,
    DialogModule,
    InputSwitchModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    TreeTableModule,
    OverlayPanelModule,
    CalendarModule,
    TableModule,
    SliderModule,
    CardModule,
    ProgressSpinnerModule,
    PaginatorModule,
    TreeSelectModule,
    SkeletonModule,
    DividerModule,
    MenuModule,
    SelectButtonModule,
    PickListModule,
    ListboxModule,
    PanelModule,
    StepsModule,
    NgbModule,
    FormsModule,
    BreadcrumbModule,
    ConfirmPopupModule,
    RouterModule,
    TabViewModule,
    RadioButtonModule,
    ToggleButtonModule,
    AccordionModule,
    SplitButtonModule,
    ToolbarModule,
    ScrollPanelModule,
    BlockUIModule,
    MultiSelectModule,
    CheckboxModule,
    DataViewModule,
    ToastModule,
    InplaceModule,
    TagModule,
    ImageModule,
    SlideMenuModule,
    //ConfirmationService,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    })
  ],
  providers: [
   // {
  //  provide: APP_INITIALIZER,
  //  multi: true,
  //  useFactory: loadCrucialData()
  //},
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy

  },
  { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    httpInterceptorProvider
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
